import { getApi, putApi } from "./helpers/apiMethods";
import type {
  PutTranscriptionConfigRequest,
  TranscriptionConfig,
} from "../types/transcription/TranscriptionConfig";

const basePath = (customerId: string) =>
  `/v1/customers/${customerId}/transcription-config`;

export async function getTranscriptionConfig(
  customerId: string,
): Promise<TranscriptionConfig> {
  const response = await getApi<TranscriptionConfig>(basePath(customerId));
  // The endpoint returns 204 with an empty body when no config exists yet,
  // which axios surfaces as "" — so || rather than ??
  return (
    response.data || { customerId, redactionOptions: [], retentionRules: [] }
  );
}

export async function putTranscriptionConfig(
  customerId: string,
  request: PutTranscriptionConfigRequest,
): Promise<TranscriptionConfig> {
  const response = await putApi<TranscriptionConfig>(
    basePath(customerId),
    request,
  );
  if (!response.data) throw new Error("Failed to update transcription config.");
  return response.data;
}
